import styled from 'styled-components';
import { color, font, query, space } from '@design/templateFns';

export const Header = styled.h2`
  color: ${color('fg')};
  ${font('headline-sm')};
  margin-top: 20px;
  margin-bottom: 40px;
  @media screen and (${query.below('tablet')}) {
    ${font('headline-xxs')};
    margin-bottom: 32px;
    padding: 0;
  }
`;

export const HistoryTable = styled.table`
  width: 100%;
  border-spacing: 0;
  border-collapse: separate;
  border-radius: 4px;
  border: 1px solid #d4d4d4;

  td {
    text-align: left;
    padding: 20px 16px 20px 20px;
  }
  th {
    font-weight: 700;
    text-align: left;
    padding: 12px 20px;
    background-color: ${color('fg')};
    color: ${color('bg')};
    line-height: 1.15;
  }
  tr:nth-child(even) {
    background-color: #f6f6f4;
  }
  th:first-child {
    border-top-left-radius: 4px;
  }
  th:last-child {
    border-top-right-radius: 4px;
  }

  @media (max-width: 600px) {
    display: none;
  }
`;

export const Text = styled.div`
  color: #000;
  ${font('body-sm')};
  padding-bottom: 0;
  margin: 0;
  line-height: 1.1;

  a {
    text-decoration: none;
    ${font('subhead-sm')};
    color: ${color('fg')};
    border-bottom: 1px solid ${color('fg')};
  }

  span {
    white-space: nowrap;
  }
  @media screen and (${query.atLeast('tablet')}) {
    ${font('body-md')};
  }

  @media screen and (${query.below('tablet')}) {
    span {
      ${font('subhead-xs')}
    }
    a {
      ${font('subhead-xs')};
    }
  }
`;

export const FilterText = styled.div`
  color: ${color('fg')};
  ${font('subhead-xs')};
  @media screen and (${query.atLeast('tablet')}) {
    ${font('subhead-sm')};
  }
`;

export const FilterToggle = styled.button`
  background-color: transparent;
  border: 0;
  padding: 0;
  margin: 0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
`;

export const FilterLabel = styled.span`
  color: ${color('gray3')};
  ${font('subhead-sm')};
  @media screen and (${query.below('tablet')}) {
    ${font('subhead-xs')};
  }
`;

export const Label = styled.span`
  color: ${color('fg')};
  ${font('subhead-xs')};

  @media screen and (${query.below('tablet')}) {
    margin-top: 16px;
    margin-bottom: 4px;
    display: block;
    &:first-of-type {
      margin-top: 0;
    }
  }
`;

export const Tab = styled.button<{ $active: boolean }>`
  ${font('subhead-sm')};
  padding: 6px 2px;
  margin-right: 48px;
  background-color: ${color('bg')};
  cursor: pointer;
  border: 0;
  outline: 0;
  border-bottom: 3px solid ${color('bg')};
  color: ${color('gray4')};
  ${({ $active }) =>
    $active &&
    `
    border-bottom: 3px solid #E60000;
    color: #242323;
  `}

  @media screen and (${query.below('tablet')}) {
    ${font('subhead-xs')};
    border-bottom: 2px solid ${color('bg')};
    ${({ $active }) =>
      $active &&
      `border-bottom: 2px solid #E60000;
    `}
  }
`;

export const Filter = styled.button<{ $active: boolean }>`
  ${font('body-md-light')};
  width: 204px;
  padding: 7px 10px 10px 16px;
  cursor: pointer;
  border: 0;
  outline: 0;
  color: ${color('gray5')};
  background-color: ${color('bg')};
  text-align: left;
  ${({ $active }) =>
    $active &&
    `background-color: #F4F4F4;
  `}
  &:hover {
    background-color: ${color('gray3')};
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  border-bottom: 1px solid #d4d4d4;
  margin-bottom: 45px;
`;

export const FilterDropdown = styled.div`
  position: relative;
  display: inline-block;
  margin-bottom: 40px;
  svg {
    margin-left: 9px;
  }
`;

export const DropdownContent = styled.div`
  display: none;
  position: absolute;
  left: 54px;
  background-color: #f9f9f9;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  &.show {
    display: block;
    top: 30px;
  }
`;

export const HistoryTableMobile = styled.table`
  border-collapse: separate;
  width: 100%;
  display: none;
  border: 1px solid #d4d4d4;
  border-radius: 4px;
  td {
    text-align: left;
    padding: 16px;
  }
  tr:nth-child(even) {
    background-color: #f6f6f4;
  }
  @media (max-width: 600px) {
    display: table;
    a {
      margin-top: 16px;
      display: inline-block;
    }
  }
`;

export const PaginationContainer = styled.div`
  justify-content: center;
  display: flex;
  margin-top: ${space('x7')};

  @media (${query.atLeast('desktop')}) {
    margin-top: ${space('x8')};
  }
`;
